import { Routes as GlobalRoutes } from "../constants/RouteConstants";;
import Home from "../pages/Home/Home";
import Register from "../pages/Auth/Register";
import Login from "../pages/Auth/Login";
import CmsPage from "../pages/CmsPages/CmsPage";
import PrivacyAndPolicy from "../pages/CmsPages/Cms-app/PrivacyPolicy";
import Faq from "../pages/CmsPages/Faq";
import FaqAPP from "../pages/CmsPages/Cms-app/FaqApp";
import Notification from "../pages/Notification/Notification";

export const publicRoutes = [
    {
        path: GlobalRoutes?.Home,
        element: <Home />,
        // element: React.lazy(() => import("../pages/Home/Home"))
    },
    {
        path: GlobalRoutes?.Register,
        element: <Register />,
        // element: React.lazy(() => import("../pages/Auth/Register")),
    },
    {
        path: GlobalRoutes?.Login,
        element: <Login />,
        // element: React.lazy(() => import("../pages/Auth/Login")),
    },
    {
        path: GlobalRoutes?.PrivacyPolicy,
        element: <CmsPage />,

        // element: React.lazy(() => import("../pages/CmsPages/CmsPage")),
    },
    // {
    //     path: GlobalRoutes?.Faq,
    //     element: React.lazy(() => import("../pages/CmsPages/Faq")),
    // },
    {
        path: GlobalRoutes?.TermsAndConditions,
        element: <CmsPage />,
        // element: React.lazy(() => import("../pages/CmsPages/CmsPage")),
    },
    {
        path: GlobalRoutes?.About,
        element: <CmsPage />,
        // element: React.lazy(() => import("../pages/CmsPages/CmsPage")),

    },
    // App 
    {
        path: GlobalRoutes?.PrivacyAndPolicyAPP,
        element:  <PrivacyAndPolicy />,
        // element: React.lazy(() => import("../pages/CmsPages/Cms-app/PrivacyPolicy")),
    },
    {
        path: GlobalRoutes?.TermsAndConditionsAPP,
        element: <PrivacyAndPolicy />,
    },
    {
        path: GlobalRoutes?.AboutAPP,
        element: <PrivacyAndPolicy />,
    },
    {
        path: GlobalRoutes?.CancellationAPP,
        element: <PrivacyAndPolicy />,
    },
    {
        path: GlobalRoutes?.CancellationPolicy,
        element: <CmsPage />,
    },
    {
        path: GlobalRoutes?.FAQPage,
        element: <Faq />,
    },
    {
        path: GlobalRoutes?.AppFAQPage,
        element: <FaqAPP />,
    },
    {
        path: GlobalRoutes?.Notification,
        element: <Notification />,
    },
   
]

// privateRouteComponent

// export const publicRouteComponent = publicRoutes.map((route, routeKey) => (
//     <Route key={routeKey} path={route.path} element={route.element} />
// ));
